import { servicesReducer as services } from './services.reducer';

const servicesReducers = { services };

export { getServiceConfig } from './services.config';
export { setConfig } from './services.actions';
export { services as serviceConstants } from './services.constant';
export { servicesReducers };
export { routeConfigSelectors } from './route-config.selectors';
